<template>
      <div ref="categories" class="catalog-categories px-2xl">

        <router-link           
          v-for="cat in catalogCategories" :to="cat.path" :key="cat.cid" 
          :class="[getActiveClass(cat.path)]"
          :title="cat.title">
          <svg-icon class="inline-icon" :id="cat.url_part"></svg-icon>
          <span class="text--m ml-xs text-gray-8" v-text="cat.title"></span>
        </router-link>

      </div>
</template>

<script>
    import { mapState, mapActions, mapGetters } from "vuex";
    import SvgIcon from "@/components/SvgIcon.vue";
    export default {
        data() 
        {
            return 
            {
                //contentReady: false;
              };
        },
        props: {
          //prodata: Object
        },
        methods:
        {
            getActiveClass(itemPath)
            {              
                var catalogCategoryPath = this.pageLayoutData.breadcrumbs[1].url;
                if(itemPath==catalogCategoryPath)
                {
                  return "router-link-active";
                }
            }
        },
        components: {
            SvgIcon,
        },
        computed: 
        {
            ...mapGetters(["catalogCategories"]),
            ...mapState(["product_data", "pageReady","pageLayoutData"])
        },
        mounted()
        {
          //alert(this.prodata.product.CatalogNo);
        }
    };
</script>
